import axios from "axios";

export const state = {
    setoptionalfees: [],
};

export const getters = {
    setoptionalfees: state => state.setoptionalfees,
};

export const mutations = {
    setSetOptionalFees(state, newValue) {
        state.setoptionalfees = newValue
    },
};

export const actions = {
    fetchSetOptionalFees({ commit }) {
        axios.get('/setoptionalfees').then(res => {
            commit('setSetOptionalFees', res.data.setoptionalfees);
        })
    },
};
